export default __webpack_public_path__ + "static/media/pact_supply_merchant.48d07462.png";